/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);

const $button = $el.find('.button-action');
const $form   = $el.find('.form');

let expanded = false;

$button.on('click', function(e) {
    e.preventDefault();

    if (expanded) {
        $button.attr('aria-expanded', 'false');
        $form.removeClass('open');
        $form.attr('aria-hidden', 'true');
        $form.removeAttr('open tabindex');
    } else {
        $button.attr('aria-expanded', 'true');
        $form.addClass('open');
        $form.attr({
            'aria-hidden': 'false',
            'open': 'true',
            'tabindex': '0'
        });
    }

    expanded = !expanded;
});

if($('.success').length) {
    Navigation.helpers.scrollTo($('.button-action'));
}

$form.on('submit', function(e) {
    e.preventDefault();

    // Reseta o formulário
    $form.find('input').attr('readonly', true);
    $form.find('.errors li').remove();
    $form.find('input').parents('.field').removeClass('field-error');
    $form.find('button[type="submit"]').attr('disabled', true);

    // Faz o envio para a api
    $.post($form.attr('action'), $form.serialize(), function(response) {

        // Mostra os erros
        if(response.error) {
            $.each(response.messages, function(element, message) {
                $('[name="'+element+'"]').parents('.field').addClass('field-error');
                $form.find('.errors').append('<li>'+message+'</li>');
            });

        // Formulário enviado com sucesso
        } else {

            window.location.href = window.location.href;

            // $('.button-action').attr('aria-expanded', 'false');
            // $form.removeClass('open');
            // $form.attr('aria-hidden', 'true');
            // $form.removeAttr('open tabindex');

            // $form.find('input').val('').blur();
            // $('.success').show();
        }

        $form.find('input').attr('readonly', false);
        $form.find('button[type="submit"]').attr('disabled', false);
    }, 'json');
});
